<template>
  <div v-if="links.length" class="FormLinksSelection">
    <h5>{{ $t("articleLinks") }}</h5>
    <div v-for="(link, index) in linksSearchedFiltered" :key="link.url">
      <LinkSelect
        :link="link"
        :linksActive="linksActive"
        @remove="removeLink(index, link.label)"
        @replace="(url) => replaceLink(index, link.label, url)" />
    </div>
  </div>
</template>

<script>
import {
  parseLinks,
  removeMarkdownLink,
  replaceMarkdownLink,
} from './utils'
import { pluck, propEq } from 'rambda'
import LinkSelect from './LinkSelect'

export default {
  components: { LinkSelect },
  props: {
    links: Array,
    text: String,
  },
  computed: {
    linksActive() {
      return parseLinks(this.text)
    },
    linksSearchedFiltered() {
      const linksActiveLabels = pluck('label', this.linksActive)

      return parseLinks(this.text)
        .map(link => {
          const linkWithOptions = this.links
            .find(propEq('label', link.label))

          return linkWithOptions?.options?.length ? linkWithOptions : link
        })
        .filter(({ label }) => linksActiveLabels.includes(label))
    },
  },
  methods: {
    removeLink(index, label) {
      const text = removeMarkdownLink(this.text, index, label)
      this.$emit('updateVariantFocused', text)
    },
    replaceLink(index, label, url) {
      const text = replaceMarkdownLink(this.text, index, label, url)
      this.$emit('updateVariantFocused', text)
    },
  },
}

</script>

<style lang="scss">
.FormLinksSelection {
}
</style>

<i18n>
{
  "en": {
    "articleLinks": "Links"
  }
}
</i18n>
